import gql from 'graphql-tag';

import { Query } from 'core';

const PROCESS_MONITOR = gql`
  query ProcessMonitor {
    loggedInUser {
      id
      pendingOperationProjects {
        id
        name
        space {
          id
          spaceType
          content {
            id
            slug
            whitelabel
          }
        }
        slug
      }
    }
  }
`;

export class ProcessMonitorQuery extends Query {
  static conf = {
    GQL: PROCESS_MONITOR,
    resultPath: 'loggedInUser',
  };
}
